import Show from '../Components/Admin/Show'

const Admin = () => {
  return (
  <>
      <Show/>
  </>
  )
  }
export default Admin